import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import java from "../IMG/java.gif";
import javascript from "../IMG/javascript.gif";
import TypeScript from "../IMG/TypeScript.png";
import cpp from "../IMG/C++.png";
import html from "../IMG/html.png";
import css from "../IMG/css.png";

import Vue from "../IMG/vue.png";
import Reactlogo from "../IMG/react.gif";
import Node from "../IMG/node.png";
import Express from "../IMG/ecpress.png";
import Vuetify from "../IMG/vuetify.svg";
import Tailwind from "../IMG/Tailwind.png";
import PrimeReact from "../IMG/PrimeReact.png";
import Spring from "../IMG/Spring Boot.png";

import MySQL from "../IMG/MySQL.png";
import MongoDB from "../IMG/MongoDB.png";
import Firebase from "../IMG/Firebase.png";
import AWS from "../IMG/AWS.png";
import Flutter from "../IMG/Flutter.png";
import Android from "../IMG/Android.png";
import Figma from "../IMG/Figma.gif";
import WordPress from "../IMG/wordpress logo.png";

import gitlab from "../IMG/GitLab.png";
import postman from "../IMG/postman.png";
import github from "../IMG/GitHub.png";

import Agile from "../IMG/Agile Methodologies.jpeg";
import Team from "../IMG/Team Collaboration.png";
import Analytical from "../IMG/Analytical & Problem-Solving.png";
import Project from "../IMG/Project Management.gif";

import PHP from "../IMG/php.png"
import cicd from "../IMG/cicd.png"
import docker from "../IMG/docker.png"
import xd from "../IMG/xd.gif"

const SkillsCarousel = () => {
  const skills = [
    // Languages
    { id: 1, category: "Languages", name: "Java (DSA)", logo: java },
    { id: 2, category: "Languages", name: "JavaScript", logo: javascript },
    { id: 3, category: "Languages", name: "TypeScript", logo: TypeScript },
    { id: 4, category: "Languages", name: "C++", logo: cpp },
    { id: 5, category: "Languages", name: "HTML5", logo: html },
    { id: 6, category: "Languages", name: "CSS3", logo: css },

    // Frameworks
    { id: 7, category: "Frameworks", name: "Vue.js", logo: Vue },
    { id: 8, category: "Frameworks", name: "React.js", logo: Reactlogo },
    { id: 9, category: "Frameworks", name: "Node.js", logo: Node },
    { id: 10, category: "Frameworks", name: "Express.js", logo: Express },
    { id: 11, category: "Frameworks", name: "Vuetify", logo: Vuetify },
    { id: 12, category: "Frameworks", name: "Tailwind CSS", logo: Tailwind },
    { id: 13, category: "Frameworks", name: "PrimeReact", logo: PrimeReact },
    { id: 14, category: "Frameworks", name: "Spring Boot", logo: Spring },

    // Tools/Platform
    { id: 15, category: "Tools/Platform", name: "MySQL", logo: MySQL },
    { id: 16, category: "Tools/Platform", name: "MongoDB", logo: MongoDB },
    { id: 17, category: "Tools/Platform", name: "Firebase", logo: Firebase },
    { id: 18, category: "Tools/Platform", name: "AWS", logo: AWS },
    { id: 19, category: "Tools/Platform", name: "Flutter", logo: Flutter },
    { id: 20, category: "Tools/Platform", name: "Android Studio", logo: Android },
    { id: 21, category: "Tools/Platform", name: "Figma", logo: Figma },
    { id: 22, category: "Tools/Platform", name: "WordPress", logo: WordPress },

    // DevOps & Testing
    { id: 23, category: "DevOps & Testing", name: "GitLab", logo: gitlab },
    { id: 24, category: "DevOps & Testing", name: "Postman", logo: postman },
    { id: 25, category: "DevOps & Testing", name: "Git/GitHub", logo: github },

    // Soft Skills
    { id: 26, category: "Soft Skills", name: "Agile Methodologies", logo: Agile },
    { id: 27, category: "Soft Skills", name: "Team Collaboration", logo: Team },
    { id: 28, category: "Soft Skills", name: "Analytical & Problem-Solving", logo: Analytical },
    { id: 29, category: "Soft Skills", name: "Project Management", logo: Project },

    { id: 30, category: "Language", name: "PHP", logo: PHP },
    { id: 32, category: "Tools/Platform", name: "Adobe XD", logo: xd },
    { id: 31, category: "DevOps & Testing", name: "CI/CD", logo: cicd },
    { id: 33, category: "DevOps & Testing", name: "Docker", logo: docker },
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <div className="bg-white shadow-md rounded-md p-6">
      <h2 className="text-2xl font-semibold mb-4">Skills</h2>
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2000}
        arrows={false}
      >
        {skills.map((skill) => (
          <div key={skill.id} className="text-center p-4">
            <img
              src={skill.logo}
              alt={skill.name}
              className="h-16 w-16 mx-auto mb-2"
            />
            <p className="text-sm font-medium">{skill.name}</p>
            <p className="text-xs text-gray-500">{skill.category}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default SkillsCarousel;
